import { render, staticRenderFns } from "./history-grade.vue?vue&type=template&id=9b287600"
import script from "./history-grade.vue?vue&type=script&lang=js"
export * from "./history-grade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports